
import Card from 'react-bootstrap/Card';
import { useState } from 'react';
import '../signiteCandidateForm.css';
import { Formik, Form } from 'formik';
import { CtcForm } from './CtcFragment';
import { PastIncrementsForm } from './PastIncrementFragment';
import SigniteTextArea from '../../../../ui-elements/signite-text-area/signiteTextArea';
import JSONPretty from 'react-json-pretty';
import { CandidateCompensationSchema } from '../../validations/candidateCompensationValidationSchema';
import { reverseTransformCompensationDetails } from '../../transformers/compensationDetailsTransformer';

const CandidateCompensationForm = ({ componentRef, onSubmit, candidateData, saveCurrentValues }) => {
  const initialData = {};
  const emptyCompensationForm = {
    totalCompensation: '',
    fixedCompensation: '',
    variableCompensation: null,
    incentive: null,
    bonus: null,
    otherBenefits: null,
    epos: null,
    fixedCtcExpectation: null,
    expectedCTC: null,
    firstYearIncrement: null,
    secondYearIncrement: null,
    additionalNotes: '',
  };

  let compensationData = candidateData?.compensationDetails
    ? reverseTransformCompensationDetails(candidateData.compensationDetails)
    : emptyCompensationForm;

  return (
    <>
      <Formik
        initialValues={compensationData || initialData}
        onSubmit={async (data) => {
          onSubmit(data, 'compensation-details');
        }}
        innerRef={componentRef}
        validationSchema={CandidateCompensationSchema}
      >
        {({ values, handleChange, handleBlur, errors, touched }) => {
          saveCurrentValues(values);
          return (
            <>
              {window.debug && window.debug == true && (
                <Card className="mb-3">
                  <Card.Title>DEBUG</Card.Title>
                  <Card.Body className="side-pad-24">
                    <JSONPretty data={values}></JSONPretty>
                    <JSONPretty data={errors}></JSONPretty>
                    <JSONPretty data={touched}></JSONPretty>
                  </Card.Body>
                </Card>
              )}
              <Card>
                <Card.Title>Cost To Company (CTC)</Card.Title>
                <Card.Body className="side-pad-24">
                  <Form>
                    <CtcForm
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      errors={errors}
                      touched={touched}
                      initialized={compensationData != null}
                    ></CtcForm>
                    <hr
                      style={{
                        marginTop: 32,
                        marginBottom: 32,
                      }}
                    />

                    <Card.Title className="ps-0">Increments in the last 2 yrs</Card.Title>
                    <PastIncrementsForm
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      errors={errors}
                      touched={touched}
                      initialized={compensationData != null}
                    ></PastIncrementsForm>

                    <hr
                      style={{
                        marginTop: 32,
                        marginBottom: 32,
                      }}
                    />
                    <Card.Title className="p-0">Additional Notes</Card.Title>
                    <SigniteTextArea
                      name={'additionalNotes'}
                      value={values.additionalNotes}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></SigniteTextArea>
                  </Form>
                </Card.Body>
              </Card>
            </>
          );
        }}
      </Formik>
    </>
  );
};
export default CandidateCompensationForm;
